import queryString from 'query-string';

class ApiUrl {
    constructor(baseUrl, auth) {
        this.baseUrl = baseUrl;
        this.auth = auth;
    }

    to(path = '', query = {}) {
        let urlPath = path ? '/' + path : '';
        let urlQuery = Object.keys(query).length ? '?' + queryString.stringify(query) : '';

        return this.baseUrl + urlPath + urlQuery;
    }

    tokenUrl(path = '', query = {}) {
        return this.to(path, {...query, token: this.auth.getToken()});
    }

    jwt(path = '', query = {}) {
        return this.to(path, {...query, jwt: this.auth.getToken()});
    }

    fixed(path = '') {
        let query = {jwt: this.auth.getToken()};

        let urlPath = path ? path : '';
        let urlQuery = Object.keys(query).length ? '?' + queryString.stringify(query) : '';

        return this.baseUrl + urlPath + urlQuery;
    }
}

export default ApiUrl;